import { defineComponent, toRefs, computed } from "@vue/composition-api";
import * as AutomationGetters from "../../../store/automation-getters";
import { useAutomationStoreGetters } from "../../../store/automation-helpers";
import DocumentClassificationSelectContainer from "./document-classification-select-container.vue";
import AutomationDocumentClassification from "./documents-listing/automation-document-classification.vue";
export default defineComponent({
  name: "DocumentsManage",
  components: {
    DocumentClassificationSelectContainer,
    AutomationDocumentClassification
  },
  props: {
    automation: {
      type: Object,
      required: true
    }
  },
  setup(props, {
    emit
  }) {
    const automationId = computed(() => props.automation.id);
    const {
      documents
    } = toRefs(props.automation.documentRequestRule);
    const {
      IS_DOCUMENT_REQUEST_EDIT_MODE
    } = useAutomationStoreGetters([AutomationGetters.IS_DOCUMENT_REQUEST_EDIT_MODE]);
    const editing = computed(() => {
      return IS_DOCUMENT_REQUEST_EDIT_MODE.value(automationId.value);
    });
    const handleDeleteDocument = documentIndex => {
      emit("delete-document", documentIndex);
    };
    const handleCreateClassification = documentClassification => {
      emit("add-document", documentClassification);
    };
    const handleEditDescription = (documentIndex, {
      description
    }) => {
      emit("edit-document", documentIndex, {
        description
      });
    };
    return {
      automationId,
      documents,
      handleDeleteDocument,
      editing,
      handleCreateClassification,
      handleEditDescription
    };
  }
});